import React, { useState } from 'react';
import './table-action-bar.scss';
import DotMenu from '../DotMenu/DotMenu';
import PropTypes from 'prop-types';
import { MAIN_CONFIG } from '../../../config/main';
import Spinner from '../Spinner/Spinner';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useRouter } from 'next/router';
import ApplicationAwardUpdate from '../ApplicationAwardUpdate/ApplicationAwardUpdate';
import CreateApplicationRecord from '../CreateApplicationRecord/CreateApplicationRecord';
import CTAButton from '../CTAButton/CTAButton';

const exportCsvPageTypes= ['DONATIONS','DISBURSEMENTS']

const TableActionBar =  ({ 
    numSelected = 0,
    pageType = '', 
    numTotal = 0, 
    visible = false, 
    tableActionBarFunctionOpenExport = (val) => {}, 
    userContext, 
    setDownloadTableActionBar, 
    isLoading = false, 
    isDonationForm = false , 
    isElements = false, 
    isArchive = false, 
    getSelectedIds, 
    pageData, 
    selectAllIds,
    customClassName = '', 
    bulkApplicationUpdate = false, 
    handleOpenModal = false,
    setModalState = () => { },
    handleClosePopup = () => { },
    handleBulkTbfAwardAdd = () => { },
    handleBulkApplicationCreate = () => { },
    selectedRowsData = []
    }) => {
    const route = useRouter()

    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)

    const showReportsMessage = () => {
        if (route.query.scholarshipId) {
            return pageData.scholarship.elements_review_board__c
        } else {
            const checkTrue = getSelectedIds.find((id) => {
                let temp = pageData.scholarships.find((scholarship) => {
                    if (scholarship.sfid === id) {
                        return scholarship.elements_review_board__c;
                    }
                });
                return temp;
            });
            return !!checkTrue;
        }
    };

    const handleCreteApplicationRecord = (e) => {
        e.preventDefault();
        setModalState({
            visible: true,
            id: 'create-application-record',
            content: <CreateApplicationRecord handleClose={handleClosePopup} numSelected={numSelected} allScholarships={pageData?.scholarships_for_draft_apps} showSelectedCount={true} handleBulkApplicationCreate={handleBulkApplicationCreate}/>
        });
    }

    const isScholarshipElementsProgram = () => { 
        if(selectAllIds === 'all'){
            return true;
        }
        let selectedScholarships = selectedRowsData?.filter(scholarship => getSelectedIds?.includes(scholarship?.sfid));
        let hasProgramElement = selectedScholarships?.map(scholarship => scholarship?.elements_program__c);
        return hasProgramElement?.includes(true);
    };
     
    const showArchiveReportsMessage = () => {

        if (route.query.scholarshipId) {
            return pageData.scholarship.application_score_archive__c
        } else {
            const checkTrue = getSelectedIds.find((id) => {
                let temp = pageData.scholarships.find((scholarship) => {
                    if (scholarship.sfid === id) {
                        return scholarship.application_score_archive__c;
                    }
                });
                return temp;
            });
            return !!checkTrue;
        }
    };

    const handleAddTbfAwardAmount = (e) => {
        e.preventDefault();
        setModalState({
            visible: true,
            id: 'application-update-award',
            content: <ApplicationAwardUpdate handleClose={handleClosePopup} numSelected={numSelected} showSelectedCount={true} onSubmit={handleBulkTbfAwardAdd} />
        });
    }

    const showArchiveReportsAndElementsMessage = () => {
        if (route.query.scholarshipId) {
            return pageData.scholarship.application_score_archive__c && pageData.scholarship.elements_review_board__c
        } else {
            const checkTrue = getSelectedIds.find((id) => {
                let temp = pageData.scholarships.find((scholarship) => {
                    if (scholarship.sfid === id) {
                        return scholarship.application_score_archive__c && scholarship.elements_review_board__c;
                    }
                });
                return temp;
            });
            return (!!checkTrue || selectAllIds === "all");
        }
    };
    const CaptalizeText = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
    const getDropdownLabel = (type) => {
        if(exportCsvPageTypes.includes(type) )
            return CaptalizeText(type).slice(0, type.length-1)+' Report'
        else
            return 'Application Information Report (XLS)'
    }
    const items = [
      {
        onClick: () => tableActionBarFunctionOpenExport("csv"),
        label: getDropdownLabel(pageType),
      },
      {
        onClick: () => tableActionBarFunctionOpenExport("pdf"),
        label: "Application Information Report (PDF)",
      },
      ...(pageType === "SCHOLARSHIPS"
        ? [
            {
              onClick: () =>
                tableActionBarFunctionOpenExport("qualifying_scholarship"),
              label: "Qualified Applicants",
            },
          ]
        : []),
    ];
    if (userContext == MAIN_CONFIG.USER_CONTEXT.DONOR && ![MAIN_CONFIG.URLS.DONOR.DONATIONS, MAIN_CONFIG.URLS.DONOR.DISBURSEMENTS, MAIN_CONFIG.URLS.DONOR.APPLICANTS].includes(location.pathname) && !isScholarshipElementsProgram()) {
        if(!isElements && !isArchive){
            items.push({
                onClick: () => {
                    let alertText;
                    const getAlert = (alertText) => (
                        <div className="save-changes-confirmation-alert">
                            <SweetAlert
                                showConfirm={false}
                                onConfirm={(e) => window.location.href = val}
                                showCancel={false}
                                cancelBtnCssClass="cta-button CTAWhite primary cta-button__text"
                                confirmBtnCssClass="cta-button CTAWhite tertiary cta-button__text"
                                className=""
                            >
                                <p className="H6DesktopBlack">{alertText}</p>
                            </SweetAlert>
                        </div>
                    );
                    switch(true){
                        case showArchiveReportsAndElementsMessage():
                            alertText='One or more of your reports could not be downloaded. Please export these reports from the Review Board page. If you are unable to download it from the Review Board page too, please reach out to your CSM for assistance.'
                            setIsOpenSweetAlert(getAlert(alertText))
                            setTimeout(() => {
                                tableActionBarFunctionOpenExport("score");
                            }, 6000)
                            break;

                        case showReportsMessage(): 
                            alertText='This report could not be downloaded. Please export this report from the Review Board page.'
                            setIsOpenSweetAlert(getAlert(alertText))
                            setTimeout(() => {
                                tableActionBarFunctionOpenExport("score");
                            }, 3000)
                            break;
                        case showArchiveReportsMessage():
                            alertText='This report has been archived, please reach out to your CSM for assistance.'
                            setIsOpenSweetAlert(getAlert(alertText))
                            setTimeout(() => {
                                tableActionBarFunctionOpenExport("score");
                            }, 3000)
                            break;
                        
                        default:
                            tableActionBarFunctionOpenExport("score");
                    }
                },
                label: "Score Report"
            })
        }
        if(!isDonationForm){
            items.push({
                onClick: () => tableActionBarFunctionOpenExport("recommendation_status"),
                label: "Contributor Status Report"
            })
        }     
    }
    if (userContext == MAIN_CONFIG.USER_CONTEXT.DONOR && [MAIN_CONFIG.URLS.DONOR.DISBURSEMENTS, MAIN_CONFIG.URLS.DONOR.DONATIONS].includes(location.pathname)) {
        items.pop()
    }


    /**
    * Updates the active tab and columns.
    * @param {number} index
     */
    const handleDownloadClick = () => {
        setDownloadTableActionBar(true);
    }

    const isReportPage = window.location.pathname == MAIN_CONFIG.URLS.DONOR.REPORTS;

    const getPageNumberString = () => `Selected ${numSelected} ${numTotal ? 'of ' + numTotal : ''}`
    const getVisibilityClass = () => visible ? 'visible ' + customClassName : ''
    const getActionBarWidth= pageType === 'APPLICATIONS' ? '100%' : '100vw'
    return (

        <div id='table-action-bar' className={getVisibilityClass()} style={{ width: getActionBarWidth}}>
            {isOpenSweetAlert}
            <div id='table-action-bar__selection-info' className='BodyDefaultBoldBlack'>
                {getPageNumberString()}
            </div>
            <div className='table-action-bar__button-spinner'>
            </div>
            {isReportPage ? <div id='table-action-bar__actions'>
                <div className='table-action-bar__spinner'>
                    {isLoading && <Spinner />}
                    <button className='table-action-bar-menu__button' type="button" onClick={handleDownloadClick}>
                        <div className="table-action-bar__action-item__icon-with-text-container">
                            <div className="table-action-bar__action-item__icon-with-text-container__text">
                                Download
                            </div>
                        </div>
                    </button>
                </div>
            </div> 
            : 
            <div id='table-action-bar__actions'>
                <button className='table-action-bar__action-item'>
                    <div className="table-action-bar__action-item__icon-with-text-container">
                        <div className="table-action-bar__action-item__icon-with-text-container__icon">
                            {pageType === 'APPLICATIONS' && <CTAButton className='status-update' onClick={handleAddTbfAwardAmount}>Add Award Amount</CTAButton>}
                            {(pageType === 'APPLICATIONS' || pageType === 'APPLICANTS')  && <CTAButton className='status-update' onClick={handleCreteApplicationRecord}>Create Applications</CTAButton>}
                            {bulkApplicationUpdate && <CTAButton className='status-update' onClick={handleOpenModal}>Update Status</CTAButton>}
                            {/* {numSelected == 1 && ['APPLICANTS', 'APPLICATIONS'].includes(pageType) && <CTAButton className='status-update'  onClick={() => tableActionBarFunctionOpenExport("pdf")}>Export PDF</CTAButton>} */}
                            {/* {numSelected == 1 && exportCsvPageTypes.includes(pageType)  && <button type='button' className='status-update'  onClick={() => tableActionBarFunctionOpenExport("csv")}>{getDropdownLabel(pageType)}</button>} */}
                       </div>
                    </div>
                </button>
                <DotMenu className='table-action-bar__action-item table-action-bar-custom-vertical-three-dots' items={items} />
            </div>}
        </div>
    );
};

TableActionBar.propTypes={ 
    setModalState: PropTypes.func,
    handleClosePopup: PropTypes.func,
    handleBulkTbfAwardAdd: PropTypes.func,
    getSelectedIds: PropTypes.string, 
    pageData: PropTypes.object, 
    selectAllIds: PropTypes.string,
    customClassName: PropTypes.string, 
    bulkApplicationUpdate: PropTypes.bool, 
    handleOpenModal: PropTypes.bool,
    userContext: PropTypes.string, 
    setDownloadTableActionBar: PropTypes.func, 
    isLoading: PropTypes.bool, 
    isDonationForm: PropTypes.bool, 
    isElements: PropTypes.bool, 
    isArchive: PropTypes.bool, 
    tableActionBarFunctionOpenExport: PropTypes.func,
    visible: PropTypes.bool,
    numTotal: PropTypes.number,
    pageType: PropTypes.string,
    numSelected: PropTypes.number,
    handleBulkApplicationCreate: PropTypes.func
}

export default TableActionBar;